import { useSelector } from "react-redux";
import { RootState } from "../state/reducers";
import { useEffect } from "react";

export const useAuth = () => {
    const { user_info } = useSelector((x: RootState) => x.auth);
    useEffect(() => {
    }, [user_info])
    return {
        user_info
    };
}
